import { render, staticRenderFns } from "./import-ticket.vue?vue&type=template&id=839b45d2"
import script from "./import-ticket.vue?vue&type=script&lang=js"
export * from "./import-ticket.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports